import API from '../config';

const base = `${API.BASE_DEV_HOST}/api/financials/financial_page`;

export const retrieve = (id: string) => `${base}/${id}/`;
export const update = (id: string) => `${base}/${id}/`;
export const destroy = (id: string) => `${base}/${id}/`;
export const create = () => `${base}/`;
export const list = () => `${base}/`;
export const createVersion = (id: string) => `${base}/${id}/create_version/`;
export const listByMeasurementPeriod = (measurementPeriodId: string) =>
  `${base}/${measurementPeriodId}/list_by_measurement_period/`;
export const getByMeasurementDateId = (measurementPeriodId: string) =>
  `${base}/${measurementPeriodId}/get_by_measurement_date/`;
export const financialLtmNtm = (measurementPeriodId: string, versionId?: string) => {
  if (versionId) {
    return `${base}/${measurementPeriodId}/financial_ltm_ntm/?version=${versionId}`;
  }
  return `${base}/${measurementPeriodId}/financial_ltm_ntm/`;
};
export const getFinancialPeriodsFiscalYear = (
  companyMeasurementDateId: number | string,
  versionId?: number | string
) => {
  if (versionId) {
    return `${base}/${companyMeasurementDateId}/financial_rfyd/?version=${versionId}`;
  }
  return `${base}/${companyMeasurementDateId}/financial_rfyd/`;
};

export const getFinancialsBasicDataListByMD = (measurementDateId: string) =>
  `${base}/${measurementDateId}/financials_basic_data_list/`;
